export const AboutModal = {
  sections: [
    {
      id: 1,
      title: "Okoa Muda na Pesa",
      description: "Okoa muda na pesa kwa kupanga harusi yako mtandaoni. Fuatilia bajeti yako, wageni wako, na watoa huduma wote kwa urahisi.",
      link: "#okoa-muda-na-pesa",
      image: "save_time_money_square.png"
    },
    {
      id: 2,
      title: "Rahisi kutumia",
      description: "Mfumo wetu umeundwa kwa ajili ya kila mtu, hata kama wewe si mtaalamu wa teknolojia unaweza kuutumia mfumo kirahisi. Panga na Ratibu shughuli yako kwa urahisi popote pale ulipo.",
      link: "#rahisi-kutumia",
      image: "easy_to_use_2_square.png"
    },
    {
      id: 3,
      title: "Watoa Huduma",
      description: "Tafuta watoa huduma bora wa Shughuli yako katika eneo lako kwa urahisi.Tunakukutanisha na watoa huduma mbalimbali wenye kukidhi mahitaji yote ili kukamilisha shughuli yako.",
      link: "/WatoaHuduma",
      image: "watoa_huduma.png"
    }
  ],
  headerContent: {

    description: "HarusiOnline tunakupa njia rahisi na ya kisasa ya kupanga shughuli yako (Harusi,Sendoff,kitchen Party,Engagement). Mfumo huu umekusudiwa kukusaidia kwenye kila hatua ya shughuli yako, kuwafahamisha watu kuhusu shughuli yako kwa kutuma taarifa,kukusanya na kurekodi ahadi na taarifa za michango kijanja pamoja na kutengeneza na kusambaza kadi za mialiko kwa wageni wako kwa hatua rahisi sana. Lakini pia tunakuwezesha kurekodi  bajeti ya shughuli yako na matumizi kwa ufuatiliaji wa kamati."
  }
};
